import { render, staticRenderFns } from "./TopVisitedSectionsPerRole.vue?vue&type=template&id=22844143&scoped=true&"
import script from "./TopVisitedSectionsPerRole.vue?vue&type=script&lang=js&"
export * from "./TopVisitedSectionsPerRole.vue?vue&type=script&lang=js&"
import style0 from "./TopVisitedSectionsPerRole.vue?vue&type=style&index=0&id=22844143&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22844143",
  null
  
)

component.options.__file = "TopVisitedSectionsPerRole.vue"
export default component.exports